import * as React from 'react';

/** Vertical event poster. Renders the real `src` when present (3:4, hard frame),
 * otherwise a textured placeholder carrying the title/sub. */
export function Poster({
  src,
  label = 'poster',
  accent = 'var(--ev-accent)',
  ink = '#18190f',
  title,
  sub,
  alt,
  style = {},
}: {
  src?: string;
  label?: string;
  accent?: string;
  ink?: string;
  title?: string;
  sub?: string;
  alt?: string;
  style?: React.CSSProperties;
}) {
  if (src) {
    return (
      <div
        style={{
          position: 'relative',
          width: '100%',
          aspectRatio: '3 / 4',
          overflow: 'hidden',
          border: 'none',
          boxShadow: '4px 4px 0 var(--ev-ink)',
          background: 'var(--ev-accent2)',
          ...style,
        }}>
        <img
          src={src}
          alt={alt ?? title ?? 'Event poster'}
          style={{ width: '100%', height: '100%', objectFit: 'cover', display: 'block' }}
        />
      </div>
    );
  }
  return (
    <div
      className="ww-grain"
      style={{
        position: 'relative',
        width: '100%',
        aspectRatio: '3 / 4',
        overflow: 'hidden',
        background: ink,
        border: 'none',
        boxShadow: '4px 4px 0 var(--ev-ink)',
        ...style,
      }}>
      <div
        style={{
          position: 'absolute',
          inset: 0,
          background: `repeating-linear-gradient(28deg, ${accent}, ${accent} 2px, transparent 2px, transparent 30px)`,
          opacity: 0.25,
        }}
      />
      <div
        style={{
          position: 'absolute',
          inset: 0,
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'space-between',
          padding: 26,
        }}>
        <span
          className="font-mono"
          style={{
            fontSize: 11,
            letterSpacing: '.18em',
            textTransform: 'uppercase',
            color: accent,
          }}>
          {label}
        </span>
        <div>
          {title ? (
            <div className="ev-disp" style={{ fontSize: 52, color: accent, lineHeight: 0.86 }}>
              {title}
            </div>
          ) : null}
          {sub ? (
            <div
              className="font-mono"
              style={{
                fontSize: 13,
                color: 'var(--paper-100)',
                marginTop: 12,
                letterSpacing: '.04em',
              }}>
              {sub}
            </div>
          ) : null}
        </div>
      </div>
    </div>
  );
}
